import { axiosInstanceProducts } from "./instance";

export const showPaymentLink = (uuid) => axiosInstanceProducts.get(`/payment-link/${uuid}`)
export const createPaymentLink = (data) => axiosInstanceProducts.post('/payment-link/pay', data);
export const formalizePayment = (data) => axiosInstanceProducts.post('/invoice', data);
export const formalizeAdvancePayment = (uuid) => axiosInstanceProducts.get(`/purse/advance-payment/formalize/${uuid}`);
export const generateElectronicInvoice = (data) => axiosInstanceProducts.post('/invoices/generate-invoice-electronic', data);
